<template>
  <v-container>
    <FormRow
      label="Current Admin Pin"
      :input-payload="password"
      :static-field="true"
    />
    <FormRow
      label="New Admin Pin"
      :input-payload="password"
      :rules="passwordRules"
      @parseNewVAl="parseNewVal($event, 'password', 'Admin / New Admin Pin')"
    />

    <FormRow
      v-if="allowStorageUpdate"
      label="Disable Secondary Storage"
      :input-payload="storageState"
      :check-box="true"
      @parseNewVAl="parseNewVal($event, 'storage', 'Admin / Secondary Storage')"
    />
  </v-container>
</template>

<script>

import FormRow from '../components/FormRow.vue'; 

import {deviceConfigMixin} from '@/mixins/deviceConfigMixin.js';

export default {
  name: 'Admin',
  components: {
    FormRow
  },
  mixins: [deviceConfigMixin],
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  computed: {
    password() {
      return this.config.device_config.system[0].admin[0].password[0];
    },
    passwordRules() {
      return [
        v => v.length <= 6 || 'Max 6 characters',
        v => !!v || 'This field is required',
      ]
    },
    allowStorageUpdate() {
      return Object.hasOwn(this.config.device_config.system[0], 'storage')
    },
    storageState() {
      return this.allowStorageUpdate ? JSON.parse(this.config.device_config.system[0].storage[0].disableSecondaryStorage[0]) : false
    }
  },
  methods: {
    parseNewVal(val, id, label) {
      let payload = {
        newValue: this.returnMappedVal(val, []),
        key: this.configPropMapper(id),
        label: label
      }

      this.$emit('settingsUpdated', payload);
    },
    configPropMapper(key) {
      let map = {
        'password': `device_config.system[0].admin[0].password[0]`,
        'storage': `device_config.system[0].storage[0].disableSecondaryStorage[0]`
      }

      return map[key];
    }
  }
}
</script>